import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export enum TimelinePoints {
  CUSTOM_INSTANCE = 'CUSTOM_INSTANCE',
  SERIES_SETTINGS = 'SERIES_SETTINGS',
  INSTANCE_HISTORY_ITEM = 'INSTANCE_HISTORY_ITEM',
  UPCOMING_INSTANCE = 'UPCOMING_INSTANCE',
}

export enum TimelineActions {
  INSTANCE_PASSED = 'INSTANCE_PASSED',
  INSTANCE_UPDATE = 'INSTANCE_UPDATE',
  INSTANCE_SKIP = 'INSTANCE_SKIP',
  INSTANCE_SCHEDULED = 'INSTANCE_SCHEDULED',

  PICKUP_CONFLICT_HANDLED = 'PICKUP_CONFLICT_HANDLED',
  RETURN_CONFLICT_HANDLED = 'RETURN_CONFLICT_HANDLED',
  SETTINGS_UPDATE = 'SETTINGS_UPDATE',

  RECURRING_ORDER_CREATED = 'RECURRING_ORDER_CREATED',
  RECURRING_ORDER_CANCELLED = 'RECURRING_ORDER_CANCELLED',
}

export enum RecurringOrderSettingsOrigin {
  LIVE_LINK_ORDER_CREATION = 'LIVE_LINK_ORDER_CREATION',
  LIVE_LINK_RECURRING_ORDER_MANAGER_PAGE = 'LIVE_LINK_RECURRING_ORDER_MANAGER_PAGE',
  LIVE_LINK_ORDER_MANAGER_PAGE = 'LIVE_LINK_ORDER_MANAGER_PAGE',
  STORE_CLOSURES_MANAGER = 'STORE_CLOSURES_MANAGER',
  STORE_DELIVERY_WINDOWS_MANAGER = 'STORE_DELIVERY_WINDOWS_MANAGER',
  INHERITED_FROM_RECURRING_SUBSCRIPTION = 'INHERITED_FROM_RECURRING_SUBSCRIPTION',
  BUSINESS_MANAGER_CUSTOMER_PAGE = 'BUSINESS_MANAGER_CUSTOMER_PAGE',
  BUSINESS_MANAGER_ORDER_PAGE = 'BUSINESS_MANAGER_ORDER_PAGE',
}

export interface TimelineItem {
  type: TimelinePoints;
  instanceWeek: string | null;
  action: TimelineActions;
  itemTimestamp: string | Date | null;
  teamMemberName: string | null;
  origin: RecurringOrderSettingsOrigin | null;
  data?: {
    serviceOrderId?: number;
    orderCode?: string;
    isSkipped?: boolean;
    pickupWindow?: string;
    returnWindow?: string;
    jobRunMoment?: string;
    isoInstanceWeek?: string;
  };
}

export interface RecurringOrderDetails {
  details: Record<
    string,
    Array<{
      name: string;
      value: string;
      subItems?: Array<{
        name: string;
        value: string;
      }>;
      link?: string;
    }>
  >;
  timeline: { items: TimelineItem[]; timeZone: string };
}

export const getRecurringOrder = (
  recurringOrderId: string | number,
): AxiosPromise<RecurringOrderDetails> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/recurring-orders/${recurringOrderId}`,
  });
};
